import { render, staticRenderFns } from "./SurveyCommonWrap.vue?vue&type=template&id=a3764fa2"
import script from "./SurveyCommonWrap.ts?vue&type=script&lang=ts&external"
export * from "./SurveyCommonWrap.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports